<div class="browse-categories-skeleton-container">
  <div class="browse-categories-skeleton-view-all">
    <ion-skeleton-text
      class="browse-categories-skeleton-view-all-button"
      animated
    ></ion-skeleton-text>
  </div>
  <div class="browse-categories-skeleton-carousel">
    <div class="browse-categories-skeleton-sidebar">
      <ion-skeleton-text
        class="browse-categories-skeleton-title"
        animated
      ></ion-skeleton-text>
      <ion-skeleton-text
        class="browse-categories-skeleton-subtitle"
        animated
      ></ion-skeleton-text>
    </div>
    <div class="browse-categories-skeleton-arrow">
      <ion-skeleton-text
        class="browse-categories-skeleton-arrow-left"
        animated
      ></ion-skeleton-text>
    </div>
    <div class="browse-categories-skeleton-items">
      <ion-skeleton-text
        class="browse-categories-skeleton-item"
        animated
      ></ion-skeleton-text>
      <ion-skeleton-text
        class="browse-categories-skeleton-item"
        animated
      ></ion-skeleton-text>
      <ion-skeleton-text
        class="browse-categories-skeleton-item"
        animated
      ></ion-skeleton-text>
      <ion-skeleton-text
        class="browse-categories-skeleton-item"
        animated
      ></ion-skeleton-text>
      <ion-skeleton-text
        class="browse-categories-skeleton-item"
        animated
      ></ion-skeleton-text>
      <ion-skeleton-text
        class="browse-categories-skeleton-item-last"
        animated
      ></ion-skeleton-text>
    </div>
    <div class="browse-categories-skeleton-arrow">
      <ion-skeleton-text
        class="browse-categories-skeleton-arrow-right"
        animated
      ></ion-skeleton-text>
    </div>
  </div>
</div>
